import { injectIntl } from 'react-intl';
import { withTracking } from '@mindtickle/ui-shell-core/Mixpanel';

import useDropdownData from '../../../Shared/hooks/useDropdownData';
import { MixpanelTrackType } from '../../type';
import useHelpData from '../../../Shared/hooks/useHelpData';
import { MixpanelEventNameType } from './type';
import HelpMenuOption from '../../../Shared/components/HelpMenuOption';
import HelpDropdown from '../../../Shared/components/HelpDropdown';
import { HELP_MENU_OPTIONS } from './config';
import { IntlType } from '~/components/GlobalHeader/Shared/type';

type HelpProps = {
  company: any;
  user: any;
  intl: IntlType;
  store: any;
  track: MixpanelTrackType<MixpanelEventNameType>;
};

const Help = (props: HelpProps) => {
  const {
    isGetSupportInitialized,
    navigate,
    berryActions,
    isBerryChatDisabledForAdmin,
    isChatSupportReady,
  } = useHelpData();
  const { isVisible, onHideDropdownContent, handleVisibilityChange } = useDropdownData();

  const actionConfig = {
    ...props,
    onHideDropdownContent,
    navigate,
    berryActions,
    isGetSupportInitialized,
    isBerryChatDisabledForAdmin,
    isChatSupportReady,
  };

  return (
    <HelpDropdown
      options={<HelpMenuOption helpMenuOptions={HELP_MENU_OPTIONS(actionConfig)} />}
      isVisible={isVisible}
      handleVisibilityChange={handleVisibilityChange}
    />
  );
};

export default withTracking()(injectIntl(Help));
